'use strict';
require('./_iter-define')(Number, 'Number', function (iterated) {
  this._l = +iterated;
  this._i = 0;
}, function () {
  var i = this._i++;
  var done = !(i < this._l);
  return { done: done, value: done ? undefined : i };
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.number.iterator.js
// module id = 307
// module chunks = 4